// @ts-strict-ignore
import { call, put, select } from 'redux-saga/effects'
import { RESULTS as PermissionState } from 'react-native-permissions'

import { navigationRef as Nav } from 'APP/Nav'
import Engage from 'APP/Services/Engage'
import { checkPostNotificationsState } from 'APP/NativeModules/PermissionsService'

import NotificationActions from 'APP/Redux/NotificationRedux'
import { isWeb } from 'APP/Helpers/checkPlatform'
import merge from 'lodash/merge'
import { RootState } from 'APP/Store/CreateStore'
import { LoginState } from 'APP/Store/Login/types'
import { PatientState } from 'APP/Store/Patient/types'

export const loginState = (state: RootState): LoginState => state.login
export const patientState = (state: RootState): PatientState => state.patient

export function* fetchNotificationPreferences(): Generator {
  yield put(NotificationActions.getNotificationPreferences())
  const login = yield select(loginState)
  const patient = yield select(patientState)
  const engage = Engage.create(login)

  let preferences = {}
  try {
    const pushPreferences = yield call(engage.getPushPreferences, patient.profile.id)
    preferences = merge(preferences, pushPreferences)

    yield put(NotificationActions.getNotificationPreferencesSuccess(preferences))
  } catch (_) {
    yield put(NotificationActions.getNotificationPreferencesFailure())
  }

  try {
    const smsPreferences = yield call(engage.getSMSPreferences, patient.profile.id)
    preferences = merge(preferences, smsPreferences)
    yield put(NotificationActions.getNotificationPreferencesSuccess(preferences))
  } catch (_) {
    yield put(NotificationActions.getNotificationPreferencesFailure())
  }
}

export function* updateNotificationPreference(preferences: Record<string, any>): Generator {
  yield put(NotificationActions.getNotificationPreferences())
  const login = yield select(loginState)
  const engage = Engage.create(login)
  const data = preferences?.data
  const patient = yield select(patientState)

  try {
    yield call(engage.updatePreferences, patient.profile.id, data)

    yield call(fetchNotificationPreferences)
  } catch (_) {
    yield put(NotificationActions.getNotificationPreferencesFailure())
  }
}

export function* triggerNotificationPermissionModal(): Generator {
  // Only check on mobile
  if (isWeb()) return

  const permissionState = yield call(checkPostNotificationsState)

  if (permissionState === PermissionState.DENIED || permissionState === PermissionState.BLOCKED) {
    yield call(Nav.navigate, 'pushNotificationPermissionModal')
  }
}
